module.exports = __webpack_public_path__ + "static/media/journal-number-accent.ac5890ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journal-number-accent.svg
// module id = 410
// module chunks = 0